import { buildGameweekWindow } from '@lib/article-blocks/gameweek-window';
import { buildStatsRequestKey, DEFAULT_VENUE } from '@lib/article-blocks/stats';
import type {
  ArticleBlockData,
  SanityGameweekRange,
  SanityPlayerReference,
  StatsVenue
} from '@lib/article-blocks/types';
import { GAMEWEEK_ONE, MAX_GAMEWEEK } from '@lib/constants';

export const UPCOMING_FIXTURES_ON_STAT_CARDS = 3;

export const resolvePlayer = (
  data: ArticleBlockData,
  reference: SanityPlayerReference | undefined
) =>
  reference?.optaUuid ? data.playersByOptaUuid[reference.optaUuid] : undefined;

export const resolveStats = (
  data: ArticleBlockData,
  venue: StatsVenue | undefined,
  range: SanityGameweekRange | undefined,
  optaUuid: string
) =>
  data.statsByRequestKey[buildStatsRequestKey(venue ?? DEFAULT_VENUE, range)]?.[
    optaUuid
  ];

export const upcomingFixtures = (
  data: ArticleBlockData,
  teamShortName: string
) =>
  buildGameweekWindow(
    data.fixturesByTeamShortName[teamShortName] ?? [],
    data.currentGameweek,
    UPCOMING_FIXTURES_ON_STAT_CARDS
  );

// With no explicit range the card covers the season so far; pre-season there
// is nothing played yet, so it reads as the whole season.
export const rangeLabel = (
  range: SanityGameweekRange | undefined,
  currentGameweek: number
): string => {
  const min = range?.minGameweek ?? GAMEWEEK_ONE;
  const max =
    range?.maxGameweek ??
    (currentGameweek >= GAMEWEEK_ONE ? currentGameweek : MAX_GAMEWEEK);
  return `Gameweek ${min}-${max}`;
};
